<template>
  <div>
    <div>
      <Base--InlineTextBlock>
        Сумма ставок: {{ stats.bets_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Сумма выигрыша: {{ stats.prizes_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Прибыль: {{ stats.profit }}
      </Base--InlineTextBlock>
    </div>
    <mines-statistics-table />
    <BaseSideButtons back />
  </div>
</template>

<script>
import BaseSideButtons from '../Base--SideButtons'
import { getMultiplier, updateMultiplier } from '../../../api/dice'
import { getGeneralStatistics } from '../../../api/mines'
import MinesStatisticsTable from '../common/Table/MinesStatisticsTable/MinesStatisticsTable'

export default {
  name: 'Mines',
  components: { MinesStatisticsTable, BaseSideButtons },
  data () {
    return {
      stats: {
        bets_sum: 0,
        prizes_sum: 0,
        profit: 0
      }
    }
  },
  mounted () {
    getGeneralStatistics().then(res => {
      this.stats = res.data
    })
  }
}
</script>

<style scoped>
</style>
